import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    // Evita inicializar mais de uma vez
    if (this.element.tomselect) return

    this.select = new TomSelect(this.element, {
      plugins: ['clear_button'], // permite limpar o campo
      create: false,
      sortField: { field: "text", direction: "asc" },
      placeholder: this.element.getAttribute("placeholder") || "",
      maxOptions: 200,
      escapeHTML: false,
      render: {
        option: function (data, escape) {
          return `<div>${data.text}</div>`;
        },
        item: function (data, escape) {
          return `<div>${data.text}</div>`;
        },
        no_results: function (data, escape) {
          return '<div class="no-results">Não encontrado</div>'
        }
      }
    })
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
    }
  }
}
